// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"c103e4cc","269":"71741451","287":"c103e4cc","712":"2bd56195"}[chunkId] + ".chunk.css";
};